import { render, staticRenderFns } from "./bind-card.vue?vue&type=template&id=221936a4&scoped=true&"
import script from "./bind-card.vue?vue&type=script&lang=js&"
export * from "./bind-card.vue?vue&type=script&lang=js&"
import style0 from "./bind-card.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./bind-card.vue?vue&type=style&index=1&id=221936a4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221936a4",
  null
  
)

export default component.exports